import { classNames } from '@utils/classNames.ts';
import type { DetailedHTMLProps, HTMLAttributes } from 'react';

export function Body4({
  children,
  className,
  ...rest
}: DetailedHTMLProps<
  HTMLAttributes<HTMLParagraphElement>,
  HTMLParagraphElement
>) {
  return (
    <span
      className={classNames(
        'text-sm font-normal text-slate-900 block',
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
